import * as angular from 'angular';
import { fn } from '@common/utils';
import { CreatePopUpOverlay, constants, NavKendoRegister } from '@common/navkendo';

/** Custom Extension for Kendo Menu */
export class InfMenu extends kendo.ui.Menu {
    private _popup: kendo.ui.Popup;

    constructor(element, options?: IInfMenuOptions) {
        if (options) {
            options.openOnClick = true;
        }
        super(element, options);

        this.bind("activate", (e: kendo.ui.MenuActivateEvent) => {
            let popup = this._popup = this._popup || e.sender.wrapper.find("[data-role=popup]").data("kendoPopup");

            // Right align dropdown to parent?
            var isRightAligned = options && options.rightAlignDropDown;
            if (isRightAligned) {
                var menuwidth = $(e.item).outerWidth(true),
                    menuHeight = $(e.item).outerHeight(true),
                    popupwidth = popup.wrapper.width(),
                    popupleft = menuwidth - popupwidth + 1,
                    popuptop = menuHeight + 3;
                popup.wrapper.css("left", popupleft).css("top", popuptop + "px");
            }

            CreatePopUpOverlay(popup, true);
        });
    }
}
NavKendoRegister(<any>InfMenu, "InfMenu");

export interface IInfMenuOptions extends kendo.ui.MenuOptions {
    rightAlignDropDown: boolean;
}

/** Options for Custom Menu Item */
export interface InfMenuItemOptions {
    /** Template for Item, single child of Item as alternative */
    ItemTemplate?: any;
    LoadItems?: () => (any[] | PromiseLike<any[]>);
    SubItems?: ((dataItem: any) => (any[] | PromiseLike<any[]>));
    /*+ for internal use */
    $angular?: any;
}

/** Custom Meun Item to dynamically add "delayed" Items (toDO : make it "really" angular aware ...)*/
export class InfMenuItem extends kendo.ui.Widget {
    options: InfMenuItemOptions;
    constructor(element, options?: InfMenuItemOptions) {
        super(element, options);
        var me = this,
            openItem: JQuery,
            loadItems = options && options.LoadItems,
            _template = me._resolveTemplate();

        // setTimout : Menu Widget on parent might not yet be available as will be created after that point in same insertion cycle ...
      window.setTimeout(() => {
        function findMenuData(key: string) {
          return me.element.parents().filter(function () {
            return $(this).data(key) !== undefined;
          }).first().data(key);
        }

        var mnu: kendo.ui.Menu | kendo.ui.ContextMenu =
          findMenuData("kendoInfMenu") ||
          findMenuData("kendoContextMenu") ||
          findMenuData("kendoMenu");

            if (!(mnu && _template && (typeof loadItems == "function")))
                return;

            me.one("open", () => InitializeItems(loadItems()));
            var id = kendo.guid(); // better way to intercept first open?
            mnu.bind("open", (e, a) => {
                // defer Initialization on first open
                var isCurrentOpenAction = $(e && e.item).find(" > ul > li[data-infitemid='" + id + "']").length;
                if (isCurrentOpenAction) {
                    openItem = $(e.item);
                    this.trigger("open");
                }
            });

            var _angular = me && me.element && me["angular"].bind(me),
                mnuItemLoading = $("<li ng-show='dataItem.Show' style='height: 20px; width : 100px' data-infitemid='" + id + "' >{{dataItem.Text}}<img ng-show='dataItem.Loading' src='./loading.gif' style='position: relative; top: -1px; margin-left: 5px' /></li>"),
                loadData = { Loading: true, Show: true, Text: "" };
            mnuItemLoading.appendTo(me.element);
            compile({ elements: [mnuItemLoading], data: [{ dataItem: loadData }] });
            //compile({  });
            function compile(e: { elements: JQuery | JQuery[], data: any[] }) {
                if (_angular) {
                    _angular("compile", function () {
                        return {
                            elements: e.elements,
                            data: e.data
                        };
                    });
                }
            };
            function cleanup() {
                if (_angular) {
                    _angular("cleanup", function () {
                        return {
                            elements: me.element.children()
                        };
                    });
                }
            };

            function InitializeItems(items: any[] | PromiseLike<any[]>) {

                var injector = <ng.auto.IInjectorService>angular.element(me.element).injector(),
                    $q = injector.get<ng.IQService>("$q"); // better a ng-directive instead of widget ?

                $q.when(items).then((items: any[]) => {
                    var popup = <kendo.ui.Popup>me.element.data("kendoPopup");
                    loadData.Loading = false;

                    var genericSubItems = typeof (options.SubItems) == "function" && ((item) => (<any>options).SubItems(items));

                    items = (items && items.length && items) || [];
                    var infos = items.map(item => {
                        var specialSubItems = item && item["Items"],
                            mnuItem = _template.clone();

                        if (specialSubItems) {
                            if (typeof (specialSubItems) == "function")
                                getSubitems = () => specialSubItems();
                            else
                                getSubitems = () => specialSubItems;

                        } else if (genericSubItems) {
                            var getSubitems = () => genericSubItems(item);
                        }

                        if (getSubitems) {
                            var subItem = $("<ul></ul>");
                            subItem.kendoInfMenuItem({
                                $angular: me.options.$angular,
                                ItemTemplate: options.ItemTemplate || _template,
                                LoadItems: getSubitems
                            });
                            subItem.appendTo(mnuItem);
                        }

                        return { dataItem: item, mnuItem: mnuItem };
                    });

                    if (infos.length > 0) {
                        infos.reverse().forEach((item, idx) => mnu.insertAfter(item.mnuItem, mnuItemLoading));

                        loadData.Show = false;
                        compile({
                            data: infos.reverse().map(item => {
                                return { dataItem: item.dataItem };
                            }), elements: me.element.children(":not(:first)") // first : loadingItem!
                        });

                        me.one(constants.NavDestroy, cleanup);
                    } else {
                        loadData.Text = "<leer>";
                        mnuItemLoading.attr("title", "leer");
                    }

                    if (popup.visible()) {
                        // WOut ReOpen  : sizing not correct ...
                        (<Function>popup.close)(true); // not published param: skipEffect -> immediate close
                        window.setTimeout(() => popup.open(), 0); // wOut Timeout : position is not correct ?
                    }
                }, err => {
                    loadData.Text = "Fehler!";
                    mnuItemLoading.attr("title", fn.resolveToError(err));
                });
            }
        });
    }

    destroy() {
        this.trigger(constants.NavDestroy);
        super.destroy();
    }

    private _resolveTemplate() {
        if (this.options && this.options["ItemTemplate"])
            return $(this.options["ItemTemplate"]);
        var result = this.element.children().first();

        if (!result.length)
            return;

        return result.remove().removeAttr("ng-non-bindable");
    }
}
NavKendoRegister(<any>InfMenuItem, "InfMenuItem", {}, ["init"]);

declare global {
    interface JQuery {
        kendoInfMenuItem(options: InfMenuItemOptions): JQuery;
        data(key: "infMenuItem"): InfMenuItem;
    }
}
